module.exports = __webpack_public_path__ + "static/img/煙波花蓮.2c49889.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/煙波花蓮.png?20181011
// module id = kWK8
// module chunks = 1